import WebsiteServiceCards from './WebsiteServiceCards';
import WebsiteServiceCard from './WebsiteServiceCard';

export default WebsiteServiceCards;

export {
  WebsiteServiceCard,
}



// WEBPACK FOOTER //
// ./src/components/admin/Website/Services/index.js